<div id="board-list">
  <div class="inner-wrap1">
    <!-- 기본게시판 //-->
    <table class="hlist-table hlist-table1" *ngIf="checkLoading()
      && (boardInfo.board_type_code == '1000' || boardInfo.board_type_code == '2001' || boardInfo.board_type_code == '2000')">
    <colgroup>
      <col class="col1">
      <col class="col2">
      <col class="col3">
      <col class="col4">
      <col class="col5">
    </colgroup>

    <thead>
    <tr>
      <th>No</th>
      <th>Subject</th>
      <th>Writer</th>
      <th>Date</th>
      <th>Hits</th>
    </tr>
    </thead>

    <tbody>
    <ng-container *ngIf="data.length > 0">
    <tr *ngFor="let item of data;index as i" class="cp" [ngClass]="{important: item.is_notice===true}" (click)="view(item)">
      <td [ngClass]="{'color-blue': item.is_notice=='1', 'bold': item.is_notice=='1'}">
        <span *ngIf="item.is_notice=='1'">Notice</span>
        <span *ngIf="item.is_notice!='1'">{{totalCount - ( ( ( params.no - 1 ) * params.row ) + i )}}</span>
      </td>
      <td class="tl">
        <ng-container *ngIf="checkReply( item ) == true">
          <span *ngFor="let col of arrayReply(item.reply_level);index as i" [ngClass]="{'reply-arrow': i > 0}"></span>
          <span class="material-icons" style="text-align:right;padding-left: 5px;">subdirectory_arrow_right</span>
        </ng-container>
        <i *ngIf="item.is_pw=='1'" class="material-icons">lock</i>
        <a class="title" [ngClass]="{'append-file': item.uploadCount > 0}"><b *ngIf="item.group_id !== ''">[{{item.group_id}}]</b> {{item.subject}}</a>
      </td>
      <td>
        <span *ngIf="boardInfo.auth_write >= 80">Admin</span>
        <span *ngIf="boardInfo.auth_write < 80">{{item.writer_name}}</span>
      </td>
      <td>{{item.write_date.substr(0,10)}}</td>
      <td>{{item.hit}}</td>
    </tr>
    </ng-container>
    <ng-container *ngIf="data.length < 1">
    <tr>
      <td colspan="5" class="center">No Posts Found</td>
    </tr>
    </ng-container>
    </tbody>
    </table>

    <div class="cb"></div>
    <!-- 기본게시판 //-->

    <!-- 카탈로그 게시판 //-->
    <table class="hlist-table hlist-table2" *ngIf="checkLoading() && ( boardInfo.board_type_code == '6000' || boardInfo.board_type_code == '6001')">
    <colgroup>
      <col style="width:10%;" />
      <col *ngIf="params.board_id=='ecatalogs'" style="width:22%;" />
      <col *ngIf="params.board_id=='ecatalogs'" style="width:33%;" />
      <col *ngIf="params.board_id!=='ecatalogs'" style="width:55%;" />
      <col style="width:20%;" />
      <col style="width:15%;" />
    </colgroup>

    <thead>
    <tr>
      <th>No</th>
      <th *ngIf="boardInfo.board_type_code == '6000'" colspan="2">Product</th>
      <th *ngIf="boardInfo.board_type_code == '6000'">Company</th>
      <th *ngIf="boardInfo.board_type_code == '6001'">Company</th>
      <th *ngIf="boardInfo.board_type_code == '6001'">Writer</th>
      <th>E-catalogue</th>
    </tr>
    </thead>

    <tbody>
    <ng-container *ngIf="data.length > 0">
    <tr *ngFor="let item of data; index as i">
      <td>{{totalCount - ( ( ( params.no - 1 ) * params.row ) + i )}}</td>
      <td class="tl" *ngIf="boardInfo.board_type_code == '6000'">[{{item.category1}} > {{item.category2}}]</td>
      <td class="tl" [innerHTML]="item.subject | safe: 'html'"></td>
      <td *ngIf="boardInfo.board_type_code == '6000'">{{item.com_kor}}</td>
      <td *ngIf="boardInfo.board_type_code == '6001'">
        <span *ngIf="boardInfo.auth_write >= 80">Admin</span>
        <span *ngIf="boardInfo.auth_write < 80">{{item.writer_name}}</span>
      </td>
      <td><a href="{{baseURL + item.title_link}}" target="_blank" class="ebook-btn">View</a></td>
    </tr>
    </ng-container>
    <ng-container *ngIf="data.length < 1">
    <tr>
      <td *ngIf="boardInfo.board_type_code == '6000'" colspan="5" class="center">No Posts Found</td>
      <td *ngIf="boardInfo.board_type_code == '6001'" colspan="4" class="center">No Posts Found</td>
    </tr>
    </ng-container>
    </tbody>
    </table>
    <!-- 카탈로그 게시판 //-->

    <ng-container *ngIf="boardInfo.write_type">
      <a class="apply-btn" (click)="write()">{{boardInfo.write_type}}</a>
    </ng-container>

    <div class="pagination-area">
      <ngb-pagination *ngIf="totalCount > 0"
        [(page)]="params.no"
        [pageSize]="params.row"
        [maxSize]="maxSize"
        [collectionSize]="totalCount"
        [boundaryLinks]="true"
        rotate="true"
        (pageChange)="loadPage($event)"
        >
        <ng-template ngbPaginationFirst>&lt;&lt;</ng-template>
        <ng-template ngbPaginationLast>&gt;&gt;</ng-template>
        <ng-template ngbPaginationPrevious>&lt;</ng-template>
        <ng-template ngbPaginationNext>&gt;</ng-template>
      </ngb-pagination>
    </div>
  </div>
</div>
